$(document).ready( function () {

  if ($(".js-cwr-product-details-main-sliderv2").length > 0) {
      $(".js-cwr-product-details-main-sliderv2").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      });
  }

    
  $(".cwr-accordion .cwr-accordion-header").click(function(){
      const content = $(this).next(".cwr-accordion-content");
      const isOpen = content.is(":visible");
  
      // Close all
      $(".cwr-accordion-content").slideUp(150);
      $(".cwr-accordion-header").removeClass("active");
  
      // Toggle only if it wasn't already open
      if (!isOpen) {
        content.slideDown(150);
        $(this).addClass("active");
      }
  });

  $('#subscribeBox').on('click', function (e) {
    // Only toggle if you're NOT clicking the actual checkbox or slider
    if (!$(e.target).is('#subscribeToggle') && !$(e.target).hasClass('slider')) {
      const checkbox = $('#subscribeToggle');
      checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
    }
  });
  
  
  // $('#subscribeToggle').on('change', function () {
  //   const isChecked = $(this).is(':checked');

  //   // Toggle active class
  //   $('#subscribeBox').toggleClass('active', isChecked);

  //   // Show/hide frequency dropdown
  //   $('#chooseFrequency').toggle(isChecked);

  //   // Optional: toggle product card style
  //   $('.cwr-choose-quantity__wrapper .product__card').toggleClass('subscribe-on', isChecked);
  // });
  $('#subscribeToggle').on('change', function () {
    const isChecked = $(this).is(':checked');
    if (isChecked) {
        $(this).attr('checked', 'checked');
        $('.cwr-choose-quantity__products_onetime').addClass('hide');
        $('.cwr-choose-quantity__products_subscribe').removeClass('hide');
        $('.cwr-choose-quantity__wrapper .cwr-choose-quantity__products_subscribe .product__card').addClass('subscribe-on');
        $('#chooseFrequency').addClass('active');         
        var selector_selling_id = $('.frequancy_selector option:selected').attr('data-id');
        var selector_vid = $('.cwr-choose-quantity__products_subscribe .product__card.subscribe-on input:checked').attr('data-variant-id');
        $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', selector_selling_id);
        $('.form--product-details-new input[name="variantid"]').val(selector_vid);
        var lastProductSave = $('.product__card.subscribe-on input:checked').next('.product__card-inner').find('.product__save-block .save-tag .sub_price').text();
        $('.cwr-total-you-save__price .save-price__text').text(lastProductSave);
        $('.subscribe-toggle-box .subtext').text('Change, pause or cancel anytime. No questions asked.');
        $('.subscribe-toggle-box').addClass('active');
        var get_text = $('.product__card.subscribe-on input:checked').attr('id');
        if(get_text.includes('2-bottle')){
          $('.cwr-total-you-save__price .best-deal__text').show();
        }else{
          $('.cwr-total-you-save__price .best-deal__text').hide();
        }
      } else {
        $(this).removeAttr('checked');
        $('.cwr-choose-quantity__products_onetime').removeClass('hide');
        $('.cwr-choose-quantity__products_subscribe').addClass('hide');
        $('#chooseFrequency').removeClass('active');
        $('.cwr-choose-quantity__wrapper .cwr-choose-quantity__products_subscribe .product__card').removeClass('subscribe-on');
        var selector_vid = $('.cwr-choose-quantity__products_onetime .product__card input:checked').attr('data-variant-id');
        $('.form--product-details-new input[name="variantid"]').val(selector_vid);
        $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', '');
        var lastProductSave = $('.cwr-choose-quantity__products_onetime .product__card input:checked').next('.product__card-inner').find('.product__save-block .save-tag .sub_price').text();
        $('.cwr-total-you-save__price .save-price__text').text(lastProductSave);
        $('.subscribe-toggle-box .subtext').text('Unlock free shipping with subscriptions');
        $('.subscribe-toggle-box').removeClass('active');
        var get_text = $('.cwr-choose-quantity__products_onetime .product__card input:checked').attr('id');
        if(get_text.includes('2-bottle')){
          $('.cwr-total-you-save__price .best-deal__text').show();
        }else{
          $('.cwr-total-you-save__price .best-deal__text').hide();
        }
      }
  });  

  $(document).on('change','.product__card input', function(e){
      let seletor_vid = $(this).attr('data-variant-id');
      $('.form--product-details-new input[name="variantid"]').val(seletor_vid);
      let selcetor_saveprice = $(this).attr('data-saving-price');
      $('.cwr-total-you-save__price .save-price__text').text(selcetor_saveprice);
      var get_text = $(this).attr('id');
      if(get_text.includes('2-bottle')){
        $('.cwr-total-you-save__price .best-deal__text').show();
      }else{
        $('.cwr-total-you-save__price .best-deal__text').hide();
      }
  });

  $('.frequancy_selector').on('change', function(e){
    var selectedOption = $(this).find(':selected');
    let planId  = selectedOption.data('id');
    console.log('plan id', planId);
    $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', planId);
  });


  // on page load get id's start
    let get_planId = $('.frequancy_selector option:selected').attr('data-id');
    $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', get_planId);
    let var_id = $('.product__card.subscribe-on input:checked').attr('data-variant-id');console.log(var_id);
    $('.form--product-details-new input[name="variantid"]').val(var_id);
    var lastProductSave = $('.product__card.subscribe-on').last().find('.product__save-block .save-tag .sub_price').text();
    $('.cwr-total-you-save__price .save-price__text').text(lastProductSave);

  // on page load get id's end

  // Add prodduct code
  $('.form--product-details-new').on('submit', function(e){
    e.preventDefault();
    var itemsArray = [];
    if ($('#subscribeToggle').is(':checked')) {   
      var var_id  = $('.form--product-details-new input[name="variantid"]').val();
      var selling_plan_id = $('.form--product-details-new input[name="variantid"]').attr('data-selling-id');
      var customItem = { id: var_id, quantity: 1, selling_plan: selling_plan_id};
      itemsArray.push(customItem);
      
    }else{
        var var_id  = $('.form--product-details-new input[name="variantid"]').val();
        var customItem = { id: var_id, quantity: 1 };
        itemsArray.push(customItem);
    }

    $.ajax({
        url: '/cart/add.js',
        method: "POST",
        dataType: "JSON",
        data: { items: itemsArray },
        success: function (data) {
          $.getJSON('/cart.js', function(data) {
            let cart_count = data.item_count;
        
            // Check if .cart__count exists, if not, create it inside #dCartBtn as the last child
            if ($('.cart__count').length === 0) {
                $('#dCartBtn').append('<span class="cart__count"></span>');
            }
        
            // Update .cart__count content if the element exists and cart_count is a number
            if (cart_count !== undefined && typeof cart_count === "number") {
                $('.cart__count').html(cart_count);
            }
        }).fail(function(error) {
            console.error('Error fetching cart data:', error);
        });
        },
        error: function (data) {
        }
    });
  })
});
